<template>
<div class="question-box" :class="{'shown':shown}">
    <div class="question-header" @click="shown = !shown">
        <div class="question-pipe">
            <div class="pipe-wrapper"></div>
        </div>
        <span class="header-title"><slot name="question"></slot></span>
    </div>
    <div class="question-content" v-if="shown">
        <p><slot name="answer"></slot></p>
    </div>
</div>
</template>

<script>
    export default {
        name: 'QuestionBox',
        components: {},
        data: function () {
            return {}
        },
        props:{
            shown:{
                type:Boolean,
                default:false,
                required:false
            }
        },
        computed: {
        },
        methods: {
        },
        mounted(){
        },
    }
</script>

<style lang="scss" scoped>
    
</style>